module.exports = __webpack_public_path__ + "img/sf-logo.6546dc23.svg";